import BaseMystery from '../BaseMystery'

const FourthGloriousMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/a/andrea/castagno/3_1450s/01assump.jpg",
		"https://www.wga.hu/art/a/andrea/sarto/3/assumpt.jpg",
		"https://www.wga.hu/art/a/andrea/sarto/3/assumpti.jpg",
		"https://www.wga.hu/art/a/asam/egid/assumpti.jpg",
		"https://www.wga.hu/art/b/bartolom/gatta/1assunta.jpg",
		"https://www.wga.hu/art/b/beschey/assumpti.jpg",
		"https://www.wga.hu/art/b/blocklan/assumpti.jpg",
		"https://www.wga.hu/art/b/boeyerma/assumpti.jpg",
		"https://www.wga.hu/art/b/brea/wing1.jpg",
		"https://www.wga.hu/art/c/cabezale/assumpti.jpg",
		"https://www.wga.hu/art/c/cabezale/assumptx.jpg",
		"https://www.wga.hu/art/c/camilo/assumpti.jpg",
		"https://www.wga.hu/art/c/carracci/annibale/2/assumpt.jpg",
		"https://www.wga.hu/art/c/carracci/annibale/1/assumpti.jpg",
		"https://www.wga.hu/art/c/carreno/assumpti.jpg",
		"https://www.wga.hu/art/c/cerezo/assumpti.jpg",
		"https://www.wga.hu/art/d/daniele/trinita.jpg",
		"https://www.wga.hu/art/f/ferrari/defenden/assumpti.jpg",
		"https://www.wga.hu/art/f/fontebas/virginas.jpg",
		"https://www.wga.hu/art/g/giaquint/assumpti.jpg",
		"https://www.wga.hu/art/g/gozzoli/6late/2tosse3.jpg",
		"https://www.wga.hu/art/g/granacci/assumpti.jpg",
		"https://www.wga.hu/art/g/greco_el/05/0503grec.jpg",
		"https://www.wga.hu/art/g/guercino/0/assumpti.jpg",
		"https://www.wga.hu/art/j/jordaens/3/assumpti.jpg",
		"https://www.wga.hu/art/k/knoller/assumpti.jpg",
		"https://www.wga.hu/art/k/koerbeck/assumpti.jpg",
		"https://www.wga.hu/art/l/lippi/flippino/carafa/2assump1.jpg",
		"https://www.wga.hu/art/l/lotto/1/06assump.jpg",
		"https://www.wga.hu/art/l/lotto/6/10ancona.jpg",
		"https://www.wga.hu/art/m/mainardi/assumpti.jpg",
		"https://www.wga.hu/art/m/malo/assumpti.jpg",
		"https://www.wga.hu/art/m/maratti/assumpti.jpg",
		"https://www.wga.hu/art/m/matteo/assumpt1.jpg",
		"https://www.wga.hu/art/m/mazzanti/assumpti.jpg",
		"https://www.wga.hu/art/m/meneses/assumpti.jpg",
		"https://www.wga.hu/art/m/mura/1/05nunzia.jpg",
		"https://www.wga.hu/art/m/muziano/assumpti.jpg",
		"https://www.wga.hu/art/p/palma/vecchio/assumpti.jpg",
		"https://www.wga.hu/art/p/palomino/assumpti.jpg",
		"https://www.wga.hu/art/p/paolo/fei/assumpti.jpg",
		"https://www.wga.hu/art/p/perugino/madonna/assumpt.jpg",
		"https://www.wga.hu/art/p/perugino/madonna/assump.jpg",
		"https://www.wga.hu/art/p/piazzett/giovanni/virgin_a.jpg",
		"https://www.wga.hu/art/p/piola/domenico/4assumpt.jpg",
		"https://www.wga.hu/art/p/poussin/2/07assump.jpg",
		"https://www.wga.hu/art/p/pietro/giovanni/assumpti.jpg",
		"https://www.wga.hu/art/p/poussin/4/02assump.jpg",
		"https://www.wga.hu/art/r/ricci/sebastia/2/theassum.jpg",
		"https://www.wga.hu/art/r/rosso/1/1assumpt.jpg",
		"https://www.wga.hu/art/r/rubens/7graphic/04sketch.jpg",
		"https://www.wga.hu/art/r/rubens/11religi/08assum.jpg",
		"https://www.wga.hu/art/r/rubens/12religi/44religi.jpg",
		"https://www.wga.hu/art/r/rubens/14religi/79relig.jpg",
		"https://www.wga.hu/art/s/sallaert/assumpti.jpg",
		"https://www.wga.hu/art/s/schut/corneli3/assumpti.jpg",
		"https://www.wga.hu/art/t/tiepolo/gianbatt/7_1760s/08assump.jpg",
		"https://www.wga.hu/art/t/tintoret/2_1550s/05assum.jpg",
		"https://www.wga.hu/art/t/tintoret/2_1550s/05assump.jpg",
		"https://www.wga.hu/art/t/tintoret/3b/3ground/8assum.jpg",
		"https://www.wga.hu/art/t/tiziano/01a/1assunt11.jpg",
		"https://www.wga.hu/art/v/vaccar/assumpti.jpg",
		"https://www.wga.hu/art/v/valdes/juan/assumpti.jpg",
		"https://www.wga.hu/art/v/veronese/02b/2assump2.jpg",
		"https://www.wga.hu/art/v/veronese/05_1580s/11assumr.jpg",
		"https://www.wga.hu/art/v/veronese/05_1580s/11assump.jpg",
	];

	const scriptureQuote = "That which is mortal must clothe itself with immortality ... \"Death is swallowed up in victory. Where, O death, is your victory? Where, O death, is your sting?\"";
	const scriptureCitation = "1 Corinthians 15:53-55 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=1%20Cor%2015%3A50-58&version=NABRE";

	return (
		<BaseMystery titleText="The Assumption"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={true} />
	);
};

export default FourthGloriousMystery;